import React from 'react';

import ComponentsMapContext from '../../store/context/ComponentsMapContext';
import { TComponentsMap } from '../../types';

type Props = {
  componentsMap: TComponentsMap;
};

const ComponentsMapProvider: Component<Props> = ({
  componentsMap = {},
  children
}) => (
  <ComponentsMapContext.Provider value={{ componentsMap }}>
    {children}
  </ComponentsMapContext.Provider>
);

export default ComponentsMapProvider;
